import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PlatformService } from '@web-frontend/shared/components/platform-disable-content/platform.service';
import { AppUpdateService } from '@web-frontend/shared/services/app-update';
import { App } from '@capacitor/app';
import { environment } from '@web-frontend/environments';
@Injectable({
  providedIn: 'root',
})
export class AppUpdateGuard implements CanActivate {
  constructor(
    private router: Router,
    private appUpdateService: AppUpdateService,
    private platform: PlatformService
  ) {}

  private async getVersion(): Promise<string> {
    try {
      const capacitorInfo = await App.getInfo();
      if (
        capacitorInfo.version &&
        /^\d+\.\d+\.\d+$/.test(capacitorInfo.version)
      ) {
        return capacitorInfo.version;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }

  public async canActivate() {
    if (!environment.production) return true;
    if (!this.platform.isAndroid() && !this.platform.isIos()) {
      return true;
    }
    try {
      const version = await this.getVersion();
      if (!version) return true;

      const result = await this.appUpdateService
        .getVersion(version)
        .toPromise();

      if (result.status === 426) {
        this.router.navigateByUrl('/app-update');
        return false;
      }
      return true;
    } catch (e) {
      return true;
    }
  }
}
